import {
  samplingPointDataCategoryName,
  samplingPointDataWhispCategoryName,
  locationItemExtraDefName,
} from '@core/survey/category'

export default {
  common: {
    active: 'Activo',
    add: 'Añadir',
    advancedFunctions: 'Funciones avanzadas',
    and: 'y',
    appName: 'Arena',
    appNameFull: '$t(common.openForis) Arena',
    apply: 'Aplicar',
    aggregateFunction: 'Función de agregación',
    aggregateFunction_other: 'Funciones de agregación',
    attribute: 'Atributo',
    attribute_other: 'Atributos',
    avg: 'Promedio',
    ascending: 'Ascendente',
    areaBased: 'basado en el área',
    back: 'Atrás',
    baseUnit: 'Unidad base',
    cancel: 'Cancelar',
    cancelConfirm: '**Hay cambios sin guardar**. \n¿Desea ignorarlos?',
    cantUndoWarning: 'Esta operación no se puede deshacer',
    cantBeDeletedUsedItem: 'Este {{item}} es utilizado por algunas definiciones de nodo y no puede ser eliminado',
    chain: 'Cadena',
    chain_other: 'Cadenas',
    childrenEmpty: 'Defina al menos un elemento hijo',
    clear: 'Limpiar',
    clone: 'Clonar',
    close: 'Cerrar',
    cloneFrom: 'Clonar de',
    cnt: 'Contar',
    code: 'Código',
    collapse: 'Colapsar',
    confirm: 'Confirmar',
    convert: 'Convertir',
    copy: 'Copiar',
    createdWith: 'Creado con',
    createdWithApp: '$t(common.createdWith) {{app}}',
    cycle: 'Ciclo',
    cycle_other: 'Ciclos',
    dateCreated: 'Fecha de creación',
    dateLastModified: 'Fecha de última modificación',
    delete: 'Eliminar',
    deleted: '¡Eliminado!',
    descending: 'Descendente',
    description: 'Descripción',
    description_other: 'Descripciones',
    designerNotes: 'Notas del diseñador',
    designerNotesInfo:
      'Las notas del diseñador solo serán visibles en el diseñador del formulario de la encuesta y no serán visibles en el formulario de entrada de datos.',
    details: 'Detalles',
    dimension: 'Dimensión',
    dimension_other: 'Dimensiones',
    done: 'Hecho',
    download: 'Descargar',
    draft: 'Borrador',
    edit: 'Editar',
    elapsed: 'Transcurrido',
    email: 'Correo electrónico',
    email_other: 'Correos electrónicos',
    emailSentConfirmation:
      'Se ha enviado un correo electrónico a {{email}}. \nPor favor, informe a la persona que revise también la carpeta de correo no deseado/spam.',
    emailSentToSelfConfirmation:
      'Debería haber recibido un correo electrónico a {{email}}. \nPor favor, revise también la carpeta de correo no deseado/spam.',
    empty: 'Vacío',
    entity: 'Entidad',
    error: 'Error',
    error_other: 'Errores',
    errorFound: '1 error encontrado',
    errorFound_other: '{{count}} errores encontrados',
    errorMessage: 'Mensaje de error',
    errorMessage_other: 'Mensajes de error',
    expand: 'Expandir',
    expandCollapse: '$t(common.expand) / $t(common.collapse)',
    export: 'Exportar',
    exportAll: 'Exportar todo',
    exportToCSV: 'Exportar a CSV',
    exportToExcel: 'Exportar a Excel',
    exportToExcelTooManyItems: 'Demasiados elementos para exportar a Excel; por favor, use la exportación a CSV.',
    expression: 'Expresión',
    false: 'Falso',
    file: 'Archivo',
    file_other: 'Archivos',
    formContainsErrors: 'El formulario contiene errores',
    formContainsErrorsCannotContinue: 'El formulario contiene errores. Por favor, corríjalos antes de continuar.',
    formContainsErrorsCannotSave: 'El formulario contiene errores. Por favor, corríjalos antes de guardar.',
    from: 'Desde',
    function: 'Función',
    goToHomePage: 'Ir a la página de inicio',
    goToSurveys: 'Ir a encuestas',
    group: 'Grupo',
    help: 'Ayuda',
    hide: 'Ocultar',
    id: 'id',
    import: 'Importar',
    importFromExcelOrCSVFile: 'Importar desde archivo Excel (.xlsx) o CSV',
    info: 'Información',
    invalid: 'INVÁLIDO',
    item: 'Artículo',
    item_other: 'Artículos',
    itemAlreadyAdded: 'Artículo ya añadido',
    label: 'Etiqueta',
    label_other: 'Etiquetas',
    language: 'Idioma',
    language_other: 'Idiomas',
    leavePageConfirmMessage:
      'Hay cambios sin guardar en el formulario. \nAl confirmar, todos los cambios se perderán. \n¿Desea continuar?',
    local: 'Local',
    loading: 'Cargando...',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    max: 'Máximo',
    med: 'Mediana',
    manage: 'Administrar',
    message_other: 'Mensajes',
    measure: 'Medida',
    measure_other: 'Medidas',
    measurePrevSteps: 'Medir pasos previos',
    measurePrevSteps_other: 'Medidas pasos previos',
    min: 'Mínimo',
    moveUp: 'Mover arriba',
    moveDown: 'Mover abajo',
    name: 'Nombre',
    new: 'Nuevo',
    next: 'Siguiente',
    no: 'No',
    noItems: '$t(common.no) $t(common.item_other)',
    notification: 'Notificación',
    notification_other: 'Notificaciones',
    notSpecified: '---No especificado---',
    orderBy: 'Ordenar por',
    of: 'de',
    ok: 'Ok',
    openForis: 'Open Foris',
    openForisShort: 'OF',
    openInNewWindow: 'Abrir en una nueva ventana',
    options: 'Opciones',
    owner: 'Propietario',
    path: 'Ruta',
    pause: 'Pausar',
    preview: 'Modo de vista previa',
    previous: 'Anterior',
    publish: 'Publicar',
    publishConfirm:
      '#### Está a punto de publicar la encuesta {{survey}} ####\n\n###### El proceso de publicación *eliminará permanentemente* la siguiente información ###### \n- Etiquetas asociadas a idiomas eliminados.\n- Registros asociados a ciclos eliminados.\n- Datos asociados a campos de formulario eliminados.\n\n###### Después de publicar: ###### \n- Los campos de formulario no se pueden cambiar de único a múltiple y viceversa.\n- Los códigos de elementos de categoría no se pueden cambiar.\n- Los elementos de categoría no se pueden eliminar.\n- Los códigos de taxonomía no se pueden cambiar.\n- Los taxones no se pueden eliminar.\n\n**¿Está seguro de que desea continuar?**',
    publishRecordValuesUpdateConfirm: `#### Publicar {{survey}} actualizará datos ya registrados ####

{{reasons}}

Esta operación puede cambiar o borrar permanentemente datos ya introducidos.

Para publicar sin actualizar los datos existentes, marque "Omitir actualización de datos" a continuación (no recomendado).`,
    publishRecordValuesUpdateConfirmHeader: 'Se actualizarán los datos de los registros existentes',
    publishRecordValuesUpdateConfirmOk: 'Publicar y actualizar datos',
    publishRecordValuesUpdateConfirmInputLabel:
      'Escriba el nombre de la encuesta "{{strongConfirmRequiredText}}" para confirmar',
    publishRecordValuesUpdateReasonAttributeChanged:
      'Los siguientes atributos serán modificados, y sus valores en los registros existentes se recalcularán automáticamente: **{{attributeNames}}**.',
    publishRecordValuesUpdateReasonCategoryOrTaxonomyExtraPropChanged:
      'Los siguientes atributos utilizan una propiedad adicional de una categoría o taxonomía que ha cambiado, lo que hará que se recalcule su valor en los registros existentes: **{{attributeNames}}**.',
    publishSkipDataUpdate: 'Omitir actualización de datos',
    publishSkipDataUpdateConfirmOk: 'Omitir actualización de datos y publicar',
    publishSkipDataUpdateImplications: 'Omitir la actualización de datos implica lo siguiente:\n\n{{implications}}',
    publishSkipDataUpdateImplicationInconsistentData:
      'Los registros existentes pueden dejar de coincidir con la nueva definición de la encuesta',
    publishSkipDataUpdateImplicationStaleValues:
      'Los valores afectados no se recalcularán hasta que se vuelvan a introducir manualmente',
    publishSkipDataUpdateImplicationChains:
      'Las cadenas de procesamiento que usan estos atributos pueden producir resultados desactualizados',
    raiseTicketInSupportForum:
      "En caso de problemas, por favor, abra un ticket con la etiqueta 'arena' en nuestro <b>Foro de soporte</b>: $t(links.supportForum)",
    record: 'Registro',
    record_other: 'Registros',
    remaining: 'Restante',
    remote: 'Remoto',
    required: 'Requerido',
    requiredField: 'campo requerido',
    reset: 'Reiniciar',
    refresh: 'Refrescar',
    pressRefreshToReloadPage: 'Pulsa Actualizar para recargar la página.',
    resume: 'Reanudar',
    retry: 'Reintentar',
    role: 'Rol',
    save: 'Guardar',
    saveAndBack: 'Guardar y volver',
    saved: '¡Guardado!',
    samplingPolygon: 'Polígono de muestreo',
    show: 'Mostrar',
    select: 'Seleccionar',
    selectOne: 'Seleccione uno...',
    selectAll: 'Seleccionar todo',
    selected: 'Seleccionado',
    showLabels: 'Mostrar etiquetas',
    showLabelsAndNames: 'Mostrar etiquetas y nombres',
    showNames: 'Mostrar nombres',
    sort: 'Ordenar',
    sortAsc: 'Ordenar ascendente',
    sortDesc: 'Ordenar descendente',
    sortNone: 'Quitar orden',
    srs: 'SRS',
    status: 'Estado',
    sum: 'Suma',
    test: 'Prueba',
    to: 'A',
    totalItems: 'Total de elementos',
    true: 'Verdadero',
    trySplittingFileIntoSmallerChunks: 'Intente dividir el archivo en partes más pequeñas.',
    type: 'Tipo',
    undefinedName: 'Nombre indefinido',
    unique: 'Único',
    upload: 'Subir',
    uploadErrorConfirm: {
      message: `Error durante la carga del archivo: {{error}}.\n
¿Intentar de nuevo?`,
    },
    uploadFileChangedError:
      'El archivo seleccionado parece haber sido modificado desde que fue seleccionado. Por favor, selecciónelo de nuevo.',
    uploadingFile: 'Subiendo archivo ({{progressPercent}}%)',
    value: 'Valor',
    view: 'Ver',
    warning: 'Advertencia',
    warning_other: 'Advertencias',
    yes: 'Sí',
    date: {
      aMomentAgo: 'Hace un momento',
      hour: 'hora',
      hour_other: 'horas',
      day: 'día',
      day_other: 'días',
      minute: 'minuto',
      minute_other: 'minutos',
      week: 'semana',
      week_other: 'semanas',
      timeDiff: "Hace {{count}} $t(common.date.{{unit}}, { 'count': {{count}} })",
    },
    paginator: {
      firstPage: 'Primera página',
      goToPage: 'Ir a la página',
      itemsPerPage: 'Elementos por página',
      lastPage: 'Última página',
      nextPage: 'Página siguiente',
      page: 'Página',
      previousPage: 'Página anterior',
    },
    table: {
      visibleColumns: 'Columnas visibles',
    },
  },
  confirm: {
    strongConfirmInputLabel: 'Para confirmar, escriba el siguiente texto: **{{strongConfirmRequiredText}}**',
  },
  dropzone: {
    acceptedFilesMessage: '(Solo se aceptarán archivos {{acceptedExtensions}} con un tamaño máximo de {{maxSize}})',
    error: {
      fileNotValid: 'El archivo seleccionado no es válido',
      fileTooBig: 'El archivo seleccionado es demasiado grande',
      invalidFileExtension: 'Extensión de archivo no válida: {{extension}}',
    },
    message: 'Arrastre y suelte un archivo aquí, o haga clic para seleccionarlo',
    selectedFile: 'Archivo seleccionado',
    selectedFile_other: 'Archivos seleccionados',
  },
  error: {
    pageNotFound: 'Página no encontrada',
  },
  geo: {
    area: 'Área',
    vertices: 'Vértices',
    perimeter: 'Perímetro',
  },
  files: {
    header: 'Archivos',
    missing: ' Archivos faltantes: {{count}}',
    totalSize: 'Tamaño total: {{size}}',
    fileName: 'Nombre del archivo',
    fileSize: 'Tamaño del archivo',
  },
  sidebar: {
    logout: 'Cerrar sesión',
  },
  header: {
    theme: {
      label: 'Tema',
      light: 'Claro',
      dark: 'Oscuro',
      system: 'Predeterminado del sistema',
    },
    myProfile: 'Mi perfil',
    qrCodeLoginDialog: {
      title: 'Iniciar sesión en Arena Mobile usando código QR',
      instructions: `1. Abra la aplicación **Arena Mobile** en su dispositivo móvil
2. Vaya al menú de **Configuración**
3. Seleccione **Conexión al servidor**
4. Presione **Iniciar sesión usando código QR**
5. Escanee el código QR que se muestra en esta pantalla`,
      success: '¡Inicio de sesión exitoso!',
      error: 'Error al generar el código QR: {{error}}',
    },
  },
  nodeDefsTypes: {
    integer: 'Entero',
    decimal: 'Decimal',
    text: 'Texto',
    date: 'Fecha',
    time: 'Hora',
    boolean: 'Booleano',
    code: 'Código',
    coordinate: 'Coordenada',
    geo: 'Geoespacial',
    taxon: 'Taxón',
    file: 'Archivo',
    entity: 'Entidad',
  },
  appModules: {
    home: 'Inicio',
    landing: 'Bienvenida',
    dashboard: 'Panel de control',
    surveyNew: 'Nueva encuesta',
    surveys: 'Encuestas',
    templateNew: 'Nueva plantilla',
    templates: 'Plantillas',
    usersAccessRequest: 'Solicitudes de acceso de usuarios',
    collectImportReport: 'Informe de importación de Collect',
    surveyInfo: 'Información de la encuesta',
    designer: 'Encuesta',
    formDesigner: 'Diseñador de formularios',
    surveyHierarchy: 'Jerarquía',
    surveyDependencyTree: 'Árbol de dependencias',
    surveyCompare: 'Comparar / actualizar desde archivo',
    category: 'Categoría',
    categories: 'Categorías',
    nodeDef: 'Definición de nodo',
    taxonomy: 'Taxonomía',
    taxonomies: 'Taxonomías',
    data: 'Datos',
    record: '$t(common.record)',
    records: '$t(common.record_other)',
    recordValidationReport: 'Informe de validación de registro',
    explorer: 'Explorador',
    map: 'Mapa',
    charts: 'Gráficos',
    export: 'Exportación de datos',
    import: 'Importación de datos',
    validationReport: 'Informe de validación',
    users: 'Usuarios',
    user: 'Perfil de usuario',
    userPasswordChange: 'Cambiar contraseña',
    userInvite: 'Invitar usuario',
    userNew: 'Nuevo usuario',
    usersSurvey: 'Lista de usuarios',
    userGroup: 'Grupo de usuarios',
    userGroup_other: 'Grupos de usuarios',
    userGroupNew: 'Nuevo grupo de usuarios',
    usersList: 'Lista de usuarios (todos)',
    user2FADevice: 'Dispositivo 2FA',
    user2FADevice_other: 'Dispositivos 2FA',
    user2FADeviceDetails: '$t(appModules.user2FADevice)',
    user2FADeviceList: '$t(appModules.user2FADevice_other)',
    analysis: 'Análisis',
    chain: 'Cadena',
    chain_other: 'Cadenas',
    virtualEntity: 'Entidad virtual',
    entities: 'Entidades virtuales',
    virtualEntity_other: '$t(appModules.entities)',
    instances: 'Instancias',
    message: 'Mensaje',
    message_other: '$t(common.message_other)',

    systemAdmin: 'Administración del sistema',
    jobMonitor: 'Monitor de trabajos',
    systemLogs: 'Registros del sistema',

    help: 'Ayuda',
    about: 'Acerca de',
    changelog: 'Registro de cambios',
    whatsNew: 'Novedades',
    disclaimer: 'Descargo de responsabilidad',
    userManual: 'Manual de usuario',
  },
  surveyDefsLoader: {
    requireSurveyPublish: 'Esta sección solo está disponible cuando la encuesta está publicada',
  },
  surveyDependencyTreeView: {
    dependencyTypesLabel: 'Tipos de dependencia',
    dependencyTypes: {
      applicable: 'Aplicabilidad',
      defaultValues: 'Valor predeterminado',
      editable: 'Editable',
      fileName: 'Nombre de archivo',
      itemsFilter: 'Filtro de elementos',
      maxCount: 'Conteo máximo',
      minCount: 'Conteo mínimo',
      parentCode: 'Código padre',
      validations: 'Validaciones',
      visible: 'Visible',
    },
    selectAtLeastOneDependencyType: 'Seleccione al menos un tipo de dependencia',
    noDependenciesToDisplay: 'No hay dependencias para mostrar',
  },
  designerView: {
    formPreview: 'Vista previa del formulario',
  },
  recordView: {
    justDeleted: 'Este registro acaba de ser eliminado',
    sessionExpired: 'La sesión del registro ha expirado',
    errorLoadingRecord: 'Error al cargar el registro: {{details}}',
    recordEditModalTitle: 'Registro: {{keyValues}}',
    recordNotFound: 'Registro no encontrado',
    keyAttributeEditing: {
      lock: 'Bloquear edición del atributo clave',
      unlock: 'Permitir editar el atributo clave',
    },
    qualifierAttributeEditing: {
      lock: 'Bloquear edición del atributo calificador',
      unlock: 'Permitir editar el atributo calificador',
    },
  },
  dataExplorerView: {
    customAggregateFunction: {
      confirmDelete: '¿Eliminar esta función de agregación personalizada?',
      sqlExpression: 'Expresión SQL',
    },
    editRecord: 'Editar registro',
  },
  mapView: {
    changeMarkerColor: 'Cambiar color del marcador',
    createRecord: 'Crear nuevo registro',
    editRecord: 'Editar registro',
    elevation: 'Elevación (m)',
    location: 'Ubicación',
    locationEditInfo: 'Haga doble clic en el mapa o arrastre el marcador para actualizar la ubicación',
    locationNotValidOrOutOfRange: 'Ubicación no válida o fuera del rango de la zona UTM',
    locationUpdated: 'Ubicación actualizada',
    options: {
      showLocationMarkers: 'Mostrar marcadores de ubicación',
      showMarkersLabels: 'Mostrar etiquetas de marcadores',
      showSamplingPolygon: 'Polígono de muestreo',
      showControlPoints: 'Puntos de control',
      showPlotReferencePoint: 'Punto de referencia de parcela',
      showUtmGrid: 'Mostrar cuadrícula UTM',
    },
    rulerTooltip: `Presione el botón para comenzar a medir distancias.
- haga clic varias veces para medir trayectos
- haga doble clic o presione la tecla ESC para terminar de medir
- presione el botón de nuevo para ocultar las mediciones`,
    samplingPointDataLayerName: 'Datos de puntos de muestreo - nivel {{level}}',
    samplingPointDataLayerNameLoading: '$t(mapView.samplingPointDataLayerName) (cargando...)',
    samplingPointItemPopup: {
      title: 'Elemento de punto de muestreo',
      levelCode: 'Código de nivel {{level}}',
    },
    selectedPeriod: 'Período seleccionado',
  },
  samplingPolygonOptions: {
    circle: 'Círculo',
    controlPointOffsetEast: 'Desplazamiento del punto de referencia este (m)',
    controlPointOffsetNorth: 'Desplazamiento del punto de referencia norte (m)',
    lengthLatitude: 'Longitud Latitud (m)',
    lengthLongitude: 'Longitud Longitud (m)',
    numberOfControlPoints: 'Número de puntos de control',
    numberOfPointsEast: 'Número de puntos de control este',
    numberOfPointsNorth: 'Número de puntos de control norte',
    offsetEast: 'Desplazamiento este (m)',
    offsetNorth: 'Desplazamiento norte (m)',
    radius: 'Radio (m)',
    rectangle: 'Rectángulo',
    samplingPolygon: 'Polígono de muestreo',
    shape: 'Forma',
  },
  kmlUploader: {
    opacity: 'opacidad',
    selectFile: 'Seleccionar archivo',
    title: 'Opciones de KML/KMZ/Shapefile',
  },
  mapBaseLayerPeriodSelector: {
    chooseAPeriodToCompareWith: 'Elija un período para comparar',
    falseColor: 'Color falso',
  },
  surveysView: {
    chains: 'Cadenas',
    confirmUpdateSurveyOwner: '¿Cambiar el propietario de la encuesta "{{surveyName}}" a "{{ownerName}}"?',
    cycles: 'Ciclos',
    datePublished: 'Fecha de publicación',
    editUserExtraProps: 'Editar propiedades adicionales de usuario',
    editUserExtraPropsForSurvey: 'Editar propiedades adicionales de usuario para la encuesta "{{surveyName}}"',
    filter: 'Filtro',
    filterPlaceholder: 'Filtrar por nombre, etiqueta o propietario',
    languages: 'Idiomas',
    nodes: 'Nodos',
    noSurveysMatchingFilter: 'No hay encuestas que coincidan con el filtro especificado',
    onlyOwn: 'Solo encuestas propias',
    records: 'Registros',
    recordsCreatedWithMoreApps: 'Registros creados con más aplicaciones:',
    status: {
      published: 'Publicada',
      draft: 'Borrador',
      'published-draft': 'Publicada/Borrador',
    },
  },
  usersAccessRequestView: {
    status: {
      ACCEPTED: 'Aceptado',
      CREATED: 'Pendiente',
    },
    acceptRequest: {
      accept: 'Aceptar',
      acceptRequestAndCreateSurvey: 'Aceptar solicitud y crear encuesta',
      confirmAcceptRequestAndCreateSurvey:
        '¿Aceptar la solicitud de acceso para **{{email}}** como **{{role}}** y crear una nueva encuesta **{{surveyName}}**?',
      error: 'Error al aceptar la solicitud de acceso: {{error}}',
      requestAcceptedSuccessfully: 'Solicitud de acceso aceptada correctamente. $t(common.emailSentConfirmation)',
      surveyLabel: 'Etiqueta de encuesta',
      surveyLabelInitial: '(Cambie el nombre y la etiqueta de la encuesta según sea necesario)',
      surveyName: 'Nombre de la encuesta',
      template: 'Plantilla',
    },
  },
  userView: {
    scale: 'Escala',
    rotate: 'Rotar',
    dragAndDrop: 'Arrastre y suelte una imagen aquí o',
    upload: 'haga clic aquí para subir',
    remove: '¿Eliminar la foto de perfil?',
    sendNewInvitation: 'Enviar nueva invitación',
    removeFromSurvey: 'Eliminar de la encuesta',
    confirmRemove: '¿Está seguro de que desea revocar el acceso de {{user}} a la encuesta {{survey}}?',
    removeUserConfirmation: 'El usuario {{user}} ha sido eliminado de la encuesta {{survey}}',
    maxSurveysUserCanCreate: 'Máximo de encuestas que el usuario puede crear',
    preferredUILanguage: {
      label: 'Idioma de interfaz de usuario preferido',
      auto: 'Detectado automáticamente ({{detectedLanguage}})',
    },
    newPassword: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    manageTwoFactorDevices: {
      label: 'Gestionar 2FA',
      title: 'Gestionar dispositivos de autenticación de dos factores',
    },
  },
  userPasswordChangeView: {
    changingPasswordForUser: 'Cambiando contraseña para el usuario: {{user}}',
    oldPassword: 'Contraseña antigua',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    changePassword: 'Cambiar contraseña',
    passwordChangedSuccessfully: '¡Contraseña cambiada correctamente!',
    notAuthorizedToChangePasswordOfAnotherUser: 'No está autorizado para cambiar la contraseña de otro usuario',
  },
  userInviteView: {
    confirmInviteSystemAdmin: '¿Invitar al usuario {{email}} como Administrador del Sistema?',
    confirmInviteSystemAdmin_other: '¿Invitar a los usuarios {{email}} como Administradores del Sistema?',
    emailSentConfirmationWithSkippedEmails:
      '$t(common.emailSentConfirmation)\n\n    $t(userInviteView.skippedEmailsNotice)',
    skippedEmailsNotice:
      'Se han omitido {{skppedEmailsCount}} direcciones (ya fueron invitadas a esta encuesta anteriormente): {{skippedEmails}}',
    invalidEmailsWarning:
      'No se pudo contactar con la dirección de correo electrónico {{emails}} y es posible que no exista. Se ha mantenido en la lista de abajo: corríjala o elimínela e intente invitar de nuevo.',
    invalidEmailsWarning_other:
      'No se pudo contactar con las direcciones de correo electrónico {{emails}} y es posible que no existan. Se han mantenido en la lista de abajo: corríjalas o elimínelas e intente invitar de nuevo.',
    groupPermissions: {
      label: 'Permisos',
      systemAdmin: '        <li>Derechos de acceso completos al sistema</li>',
      surveyManager:
        '        <li>Encuestas: \n          <ul>\n            <li>crear</li>\n            <li>clonar</li>\n            <li>editar encuestas propias</li>\n            <li>eliminar encuestas propias</li>\n          </ul>\n        </li>\n        <li>Usuarios:\n          <ul>\n            <li>invitar usuarios a encuestas propias</li>\n          </ul>\n        </li>\n        $t(userInviteView.groupPermissions.dataAnalyst)',
      surveyAdmin:
        '        <li>Encuestas: \n          <ul>\n            <li>clonar</li>\n            <li>editar encuestas propias</li>\n            <li>eliminar encuestas propias</li>\n          </ul>\n        </li>\n        <li>Usuarios:\n          <ul>\n            <li>invitar usuarios a encuestas propias</li>\n          </ul>\n        </li>\n        $t(userInviteView.groupPermissions.dataAnalyst)',
      surveyEditor:
        '        <li>Encuestas: \n          <ul>\n            <li>editar encuestas propias</li>\n          </ul>\n        </li>\n        $t(userInviteView.groupPermissions.dataAnalyst)',
      dataAnalyst:
        '        <li>Datos: \n          <ul>\n            $t(userInviteView.groupPermissions.dataCleanserData)\n            <li>acceso a la herramienta Mapa</li>\n          </ul>\n        </li>\n        <li>Análisis:\n          <ul>\n            <li>derechos de acceso completos a todas las herramientas</li>\n          </ul>\n        </li>',
      dataCleanser:
        '        <li>Datos: \n          <ul>\n            $t(userInviteView.groupPermissions.dataCleanserData)\n          </ul>\n        </li>',
      dataCleanserData:
        '        $t(userInviteView.groupPermissions.dataEditorData)\n        <li>acceso a las herramientas de validación de datos</li>\n        <li>enviar registros a la fase de “Análisis”</li>',
      dataEditor:
        '        <li>Datos: \n          <ul>$t(userInviteView.groupPermissions.dataEditorData)</ul>\n        </li>',
      dataEditorData:
        '        <li>añadir nuevos registros (encuestas propias)</li>\n        <li>editar registros existentes (encuestas propias)</li>\n        <li>enviar registros a la fase de “Limpieza”</li>',
    },
    messageOptional: 'Mensaje (opcional)',
    messageInfo:
      'El mensaje aparecerá en el correo electrónico enviado al usuario. Puede ser texto simple o lenguaje Markdown (https://www.markdownguide.org).',
    sendInvitation: 'Enviar invitación',
    surveyNotPublishedWarning:
      '**Advertencia**: la encuesta no está publicada. Los usuarios solo pueden ser invitados con los roles de ***$t(auth:authGroups.systemAdmin.label)*** y ***$t(auth:authGroups.surveyAdmin.label)***. Si desea invitar a usuarios con otros roles, primero debe publicar la encuesta.',
    typeEmail: 'Escriba una dirección de correo electrónico y luego presione el botón Añadir',
  },
  user: {
    mapApiKeys: {
      title: 'Claves API del mapa',
      mapProviders: {
        planet: 'Planet',
      },
      keyIsCorrect: 'Esta clave API es válida',
      keyIsNotCorrect: 'Esta clave API NO es válida',
    },
    title: 'Título',
    titleValues: {
      mr: 'Sr',
      ms: 'Sra',
      preferNotToSay: 'Prefiero no decirlo',
    },
  },
  chainView: {
    baseUnit: {
      confirmDelete:
        'Al eliminar la unidad base, se desmarcarán todas las selecciones de "variable basada en área". ¿Continuar?',
    },
    downloadSummaryJSON: 'Descargar resumen (JSON)',
    mauFile: {
      upload: 'Subir MAU.zip',
      download: 'Descargar MAU.zip',
      delete: 'Eliminar MAU.zip',
      confirmCycleAssociation: 'El archivo MAU.zip se asociará al ciclo actual ({{cycle}}). ¿Desea continuar?',
      confirmReplace: 'Ya se ha subido un archivo MAU.zip para esta cadena. ¿Desea reemplazarlo?',
      confirmDelete: '¿Eliminar el archivo MAU.zip subido para esta cadena?',
      uploadComplete: 'Archivo MAU.zip subido correctamente',
      deleteComplete: 'Archivo MAU.zip eliminado',
      invalidFileExtension: 'Seleccione un archivo .zip',
    },
    phase1Category: 'Categoría de primera fase',
    phase1CategoryInfo: 'Seleccione la categoría que contiene las muestras de la primera fase.',
    phase2JoinEntity: {
      label: 'Entidad de unión (2ª fase)',
      info: 'Entidad utilizada para unir la unidad base con la categoría de 1ª fase: la propia entidad de la unidad base, o una de sus entidades superiores.',
    },
    phase2AsSamplingPointData: {
      label: 'Unir usando el enlace de Sampling Point Data',
      info: 'La(s) clave(s) de la entidad de 2ª fase se leen de la tabla de Sampling Point Data, que es la misma tabla utilizada para la 1ª fase.',
    },
    phase1JoinAttribute: {
      label: 'Atributo de unión (1ª fase)',
      info: 'Seleccione la columna de la tabla $t(chainView.phase1Category) (una propiedad adicional, o "code") utilizada para unirla con la entidad de unión de la 2ª fase.',
    },
    phase2JoinAttribute: {
      label: 'Atributo de unión (2ª fase)',
      info: 'Seleccione el atributo (de la entidad de 2ª fase) para unir con la tabla de 1ª fase; su valor se compara con el atributo de unión de la 1ª fase anterior.',
    },
    formLabel: 'Etiqueta de cadena de procesamiento',
    basic: 'Básico',
    records: 'Registros',
    recordsInStepCount: '{{step}}: {{recordsCount}}',
    submitOnlyAnalysisStepDataIntoR: 'Enviar solo datos de pasos de análisis a RStudio',
    submitOnlySelectedRecordsIntoR: 'Enviar solo registros seleccionados a RStudio',
    includeEntitiesWithoutData: 'Incluir entidades sin datos',
    cannotStartRStudio: {
      common: 'No se puede iniciar RStudio',
      noRecords: '$t(chainView.cannotStartRStudio.common): no hay registros para enviar',
      surveyNotPublished: '$t(chainView.cannotStartRStudio.common): primero publique la encuesta',
    },
    nonResponseBiasCorrection: 'Corrección de sesgo por no respuesta',
    nonResponseBiasCorrectionInfo:
      "Para implementar el método de ajuste por clases de ponderación, agregue 'design_psu' y 'design_ssu' a la tabla de categorías del estrato como propiedades numéricas adicionales.",
    pValue: 'Valor P',
    resultsBackFromRStudio: 'Resultados leídos de RStudio',
    resultsBackFromRStudioInfo:
      'Habilite esta opción si los atributos de resultado calculados en RStudio deben importarse de vuelta al servidor de Arena. Este proceso puede ser lento.',
    samplingDesign: 'Diseño de muestreo',
    samplingDesignDetails: 'Detalles del diseño de muestreo',
    samplingStrategyLabel: 'Estrategia de muestreo',
    samplingStrategy: {
      simpleRandom: 'Muestreo aleatorio simple',
      systematic: 'Muestreo sistemático',
      stratifiedRandom: 'Muestreo aleatorio estratificado',
      stratifiedSystematic: 'Muestreo sistemático estratificado',
      twoPhase: 'Muestreo de dos fases',
    },
    statisticalAnalysis: {
      header: 'Análisis estadístico',
      entityToReport: 'Entidad a informar',
      entityWithoutData: 'La entidad {{name}} no tiene datos',
      filter: 'Filtro (script R)',
      reportingMethod: 'Método de informe',
      reportingMethods: {
        dimensionsCombined: 'Combinación de dimensiones',
        dimensionsSeparate: 'Dimensiones por separado',
      },
      reportingArea: 'Área total de informe (ha) (Opcional)',
      reportingAreaInfo: `Con muestreo estratificado, proporcione las áreas de los estratos en la tabla de categorías del atributo de estrato (nombre de la columna 'area')`,
    },
    stratumAttribute: 'Atributo de estrato',
    stratumAttributeInfo: 'Seleccione la variable utilizada para estratificar la muestra.',
    stratumAttribute2ndPhaseInfo:
      'Seleccione la variable utilizada para subestratificar la muestra de la primera fase antes de extraer la submuestra final y detallada. Solo se muestran los atributos cuyo nombre también aparece como columna de la categoría de la 1ª fase.',
    postStratificationAttribute: 'Atributo de postestratificación',
    areaWeightingMethod: 'Método de ponderación de área',
    clusteringEntity: 'Entidad de agrupación',
    clusteringEntityInfo:
      'La entidad que define las unidades primarias de muestreo. Nota: se utiliza exclusivamente para el análisis de conglomerados dentro del marco del paquete R survey.',
    clusteringOnlyVariances: 'Agrupación solo para varianzas',
    errorNoLabel: 'La cadena debe tener una etiqueta válida',
    dateExecuted: 'Fecha de ejecución',
    deleteChain: 'Eliminar cadena',
    deleteConfirm: '¿Eliminar esta cadena de procesamiento?\n\n$t(common.cantUndoWarning)',
    deleteComplete: 'Cadena de procesamiento eliminada',
    cloneFromAnotherSurvey: 'Clonar desde otro estudio',
    cloneFromAnotherSurveyDialog: {
      title: 'Clonar cadena desde otro estudio',
      sourceSurvey: 'Estudio de origen',
      sourceChain: 'Cadena de origen',
      entityCheck: 'Compatibilidad de entidades',
      entityMissing: 'falta en el estudio destino',
      skipMissingEntities: 'Omitir atributos de análisis de entidades que faltan en el estudio destino',
      noAnalysisAttributes: 'Esta cadena no tiene atributos de análisis',
      cloneComplete: 'Cadena clonada correctamente',
      missingEntities: 'No se puede clonar: las siguientes entidades no existen en el estudio destino: {{entities}}',
    },
    cannotSelectNodeDefNotBelongingToCycles:
      'La definición de nodo "{{label}}" no se puede seleccionar porque no pertenece a todos los ciclos de la cadena de procesamiento',
    cannotSelectCycle:
      'Este ciclo no se puede seleccionar porque algunas definiciones de nodo no pertenecen a este ciclo',
    copyRStudioCode:
      '#### Está a punto de abrir un servidor RStudio #### \n\n##### Haga clic en el botón OK y estos comandos se copiarán en su portapapeles. ##### \n\n###### Se abrirá RStudio Server; una vez que la consola de RStudio esté activa, pegue y ejecute las siguientes líneas para importar el código de la cadena: ###### \n\n{{rStudioCode}}\n',
    copyRStudioCodeLocal:
      "#### Cadena de procesamiento a RStudio #### \n\n###### Haga clic en el botón OK y estos comandos se copiarán en su portapapeles. ###### \n\n###### Inicie RStudio en su máquina (debe tener el paquete 'rstudioapi' instalado). ###### \n\n###### Una vez que la consola de RStudio esté activa, pegue y ejecute las siguientes líneas para importar el código de la cadena: ###### \n\n\n{{rStudioCode}}\n\n",
    entities: {
      new: 'Entidad virtual',
    },
    reportingDataCategory: 'Nombre de la tabla de categorías de informes',
    reportingDataAttribute: 'Atributo para {{level}}',
    reportingDataTableAndJoinsWithAttributes: 'Tabla de datos de informes y uniones con atributos',
    showSamplingAttributes: 'Mostrar atributos de muestreo',
  },
  instancesView: {
    title: 'Instancias',
    terminate: 'Terminar',
  },
  chain: {
    quantitative: 'Cuantitativo',
    categorical: 'Categórico',
    addQuantitative: 'Agregar atributo cuantitativo',
    addCategorical: 'Agregar atributo categórico',
    emptyNodeDefs: '$t(validationErrors:analysis.analysisNodeDefsRequired)',
    entityExcludedInRStudioScripts:
      'la entidad y todas las variables de resultado relacionadas se excluirán en los scripts de RStudio',
    entityWithoutData: 'La entidad {{name}} no tiene datos; $t(chain.entityExcludedInRStudioScripts)',
    entityNotInCurrentCycle:
      'La entidad {{name}} no está disponible en el ciclo actual; $t(chain.entityExcludedInRStudioScripts)',
    error: {
      invalidToken: 'Token no válido o caducado',
    },
  },
  itemsTable: {
    unused: 'Sin usar',
    noItemsAdded: 'No se añadieron elementos',
  },
  expression: {
    functionHasTooFewArguments:
      'La función {{fnName}} requiere al menos {{minArity}} argumentos (se obtuvieron {{numArgs}})',
    functionHasTooManyArguments:
      'La función {{fnName}} solo acepta como máximo {{maxArity}} argumentos (se obtuvieron {{numArgs}})',
    identifierNotFound: 'Atributo o entidad "{{name}}" no encontrado',
    invalid: 'Expresión no válida: {{details}}',
    invalidAttributeValuePropertyName:
      'Nombre de propiedad de valor de atributo no válido: {{attributeName}}.{{propName}}',
    invalidCategoryExtraProp: 'Nombre de propiedad extra de categoría no válido: {{propName}}',
    invalidCategotyName: 'Nombre de categoría no válido: {{name}}',
    invalidTaxonomyExtraProp: 'Nombre de propiedad extra de taxonomía no válido: {{propName}}',
    invalidTaxonomyName: 'Nombre de taxonomía no válido: {{name}}',
    invalidTaxonVernacularNameLanguageCode:
      'Código de idioma de nombre vernáculo de taxón no válido: {{vernacularLangCode}}',
    missingFunctionParameters: 'Parámetros de función faltantes',
    undefinedFunction: 'Función indefinida: {{name}}',
  },

  // ====== Help views
  helpView: {
    about: {
      text: `
Acerca de
========

$t(common.appNameFull)
--------
 
 * Desarrollado por: $t(links.openforis)
 * Versión: {{version}}
 * Sitio web: $t(links.openforisArenaWebsite)
 * Tutoriales en video de Arena en la Academia de aprendizaje en línea de FAO: $t(links.arenaVideoTutorialsInFaoElearningAcademy)
 * Tutoriales en video de Arena en YouTube: $t(links.arenaVideoTutorialsInYouTube)
 * Foro de soporte: $t(links.supportForum)
 * Arena en GitHub: $t(links.arenaInGitHub)
 * Scripts R de Arena en GitHub: $t(links.arenaRScriptsInGitHub)
`,
    },
    changelog: {
      title: '$t(appModules.changelog)',
    },
  },
  languagesEditor: {
    languages: 'Idioma(s)',
  },
  taxonomy: {
    header: 'Taxonomía',
    cantBeDeleted: "$t(common.cantBeDeletedUsedItem, {'item': 'taxonomía'})",
    confirmDelete: '¿Eliminar la taxonomía {{taxonomyName}}?\n$t(common.cantUndoWarning)',
    cloneFromAnotherSurvey: {
      title: 'Clonar taxonomía de otra encuesta',
      sourceSurvey: 'Encuesta de origen',
      sourceTaxonomy: 'Taxonomía de origen',
      loadingSurveys: 'Cargando encuestas...',
      noSurveysAvailable: 'No hay encuestas disponibles',
      selectSurveyFirst: 'Seleccione primero una encuesta',
      loadingTaxonomies: 'Cargando taxonomías...',
      noTaxonomiesAvailable: 'No hay taxonomías disponibles en la encuesta seleccionada',
    },
    edit: {
      taxonomyListName: 'Nombre de la lista de taxonomía',
      taxaNotImported: 'Taxones no importados',
      family: 'Familia',
      genus: 'Género',
      scientificName: '$t(surveyForm:nodeDefTaxon.scientificName)',
      synonym: 'Sinónimo / Latín',
      extraPropsNotDefined: 'Propiedades extra no definidas para esta taxonomía',
      importMissingPublishedTaxa:
        '{{count}} taxón/taxa publicado/s no encontrado/s en el archivo importado y dejado/s sin cambios. Códigos: {{codes}}',
      importMissingPublishedTaxaTruncated: '$t(taxonomy.edit.importMissingPublishedTaxa) (+{{extra}} más)',
    },
    taxaCount: 'Recuento de taxones',
    vernacularNameLabel: 'Etiqueta de nombre vernáculo',
  },
  categoryList: {
    batchImport: 'Importar categorías en lote (desde ZIP)',
    batchImportCompleteSuccessfully:
      '¡{{importedCategories}} categorías importadas correctamente!\n{{insertedCategories}} nuevas\n{{updatedCategories}} actualizadas',
    cloneFromAnotherSurvey: {
      title: 'Clonar categoría de otra encuesta',
      sourceSurvey: 'Encuesta de origen',
      sourceCategory: 'Categoría de origen',
      loadingSurveys: 'Cargando encuestas...',
      noSurveysAvailable: 'No hay encuestas disponibles',
      selectSurveyFirst: 'Seleccione primero una encuesta',
      loadingCategories: 'Cargando categorías...',
      noCategoriesAvailable: 'No hay categorías disponibles en la encuesta seleccionada',
    },
    itemsCount: 'Recuento de elementos',
    structure: 'Estructura',
    types: {
      flat: 'Plana',
      hierarchical: 'Jerárquica',
      reportingData: 'Datos de informes',
      geoPackage: 'GeoPackage',
      samplingPointData: 'Datos de puntos de muestreo',
    },
  },
  categoryEdit: {
    header: 'Categoría',
    addLevel: 'Añadir nivel',
    categoryName: 'Nombre de la categoría',
    cantBeDeleted: "$t(common.cantBeDeletedUsedItem, {'item': 'categoría'})",
    cantBeDeletedLevel: "$t(common.cantBeDeletedUsedItem, {'item': 'nivel de categoría'})",
    confirmDelete: '¿Eliminar la categoría {{categoryName}}?\n$t(common.cantUndoWarning)',
    confirmDeleteEmptyCategory: 'La categoría está **vacía** y se eliminará. ¿Continuar?',
    confirmDeleteLevel:
      "¿Eliminar el nivel de categoría '{{levelName}}' con todos los elementos?\n$t(common.cantUndoWarning)",
    confirmDeleteItem: '¿Eliminar el elemento?\n\n$t(common.cantUndoWarning)',
    confirmDeleteItemWithChildren: '¿Eliminar el elemento con todos los hijos?\n\n$t(common.cantUndoWarning)',
    convertToReportingDataCategory: {
      buttonLabel: 'Convertir a datos de informes',
      confirmMessage:
        "¿Convertir esta categoría a una categoría de datos de informes?\n\nLos niveles se renombrarán a level_1, level_2... level_N y se añadirá una propiedad extra 'area' a los elementos.",
    },
    convertToSimpleCategory: {
      confirmMessage: '¿Convertir esta categoría de datos de informes a una categoría simple?',
    },
    convertToSamplingPointDataCategory: {
      buttonLabel: 'Convertir a Datos de puntos de muestreo',
      confirmMessage: `¿Convertir esta categoría en la categoría de Datos de puntos de muestreo?\n\nLa categoría se renombrará a '${samplingPointDataCategoryName}' y se añadirá una propiedad extra '${locationItemExtraDefName}' a los elementos.`,
    },
    convertToGeoPackageCategory: {
      buttonLabel: 'Convertir a categoría GeoPackage',
      confirmMessage: `¿Convertir esta categoría en una categoría GeoPackage?\n\nSe añadirá una propiedad extra '${locationItemExtraDefName}' a los elementos.`,
    },
    convertGeoPackageCategoryToSimple: {
      buttonLabel: 'Convertir a categoría simple',
      confirmMessage: `¿Convertir esta categoría GeoPackage en una categoría simple?\n\nSe desbloqueará la propiedad extra '${locationItemExtraDefName}', para que pueda renombrarse, cambiar de tipo o eliminarse como cualquier otra propiedad extra. Sus datos no se ven afectados.`,
    },
    convertSamplingPointDataCategoryToSimple: {
      buttonLabel: 'Convertir a categoría simple',
      confirmMessage: `¿Convertir esta categoría de Datos de puntos de muestreo en una categoría simple?\n\nSe borrará el nombre de la categoría (deberá asignarle uno nuevo), y se desbloqueará la propiedad extra '${locationItemExtraDefName}', para que pueda renombrarse, cambiar de tipo o eliminarse como cualquier otra propiedad extra. Sus datos no se ven afectados.`,
    },
    geoPackageCategory: 'Esta categoría tiene capacidades geográficas',
    geoPackageCategoryInfo: `Esta categoría tiene una propiedad extra llamada '${locationItemExtraDefName}', que permite exportarla como un archivo GeoPackage.`,
    samplingPointDataCategoryType: 'Esta es la categoría de Datos de puntos de muestreo',
    samplingPointDataCategoryTypeInfo: `Esta es una categoría predefinida para datos de puntos de muestreo. Tiene una propiedad extra llamada '${locationItemExtraDefName}', que permite exportarla como un archivo GeoPackage.`,
    samplingPointDataCategoryLocationMissing: `Falta la propiedad extra '${locationItemExtraDefName}'`,
    createCategory: {
      menuLabel: 'Añadir categoría',
      simple: 'Categoría simple',
      otherTypes: 'Más tipos de categoría',
    },
    createSamplingPointDataCategory: {
      buttonLabel: 'Categoría de Datos de puntos de muestreo',
      description:
        'Categoría predefinida para datos de puntos de muestreo, que incluye un campo de ubicación para cada elemento.',
      message: `¿Crear una nueva categoría de Datos de puntos de muestreo?\n\nSe añadirá una propiedad extra '${locationItemExtraDefName}' a los elementos.`,
    },
    createGeoPackageCategory: {
      buttonLabel: 'Categoría con capacidades geográficas',
      description:
        'Añade un campo de ubicación a los elementos, para que la categoría se pueda exportar como un archivo GeoPackage.',
      message: `¿Crear una nueva categoría con capacidades geográficas?\n\nSe añadirá una propiedad extra '${locationItemExtraDefName}' a los elementos.`,
    },
    deleteItem: 'Eliminar elemento',
    level: {
      title: 'Nivel {{levelPosition}}',
      noItemsDefined: 'No se definieron elementos',
      selectItemFromPreviousLevel: 'Seleccione un elemento del nivel anterior',
    },
    importSummary: {
      columns: 'Columna',
      columnTypeSummary: 'Nivel {{level}} $t(categoryEdit.importSummary.columnType.{{type}})',
      columnTypeExtra: '$t(extraProp.label)',
      columnTypeDescription: 'Descripción ({{language}})',
      columnTypeLabel: 'Etiqueta ({{language}})',
      columnType: {
        code: 'código',
        description: 'descripción',
        label: 'etiqueta',
        extra: '$t(extraProp.label)',
      },
      dataType: 'Tipo de datos',
      title: 'Resumen de importación de categoría',
    },
    reportingData: 'Datos de informes',
    exportToGeoPackage: 'Exportar a GeoPackage',
    exportToGeoPackageSkippedItems: '{{count}} elemento(s) sin una ubicación válida fueron omitidos.',
    generateSamplingPointDataWhisp: {
      buttonLabel: 'Generar análisis Whisp',
      confirmMessage: `¿Generar el análisis Whisp para todos los puntos de muestreo?

- cada punto de muestreo con una ubicación será enviado a Open Foris Whisp para el análisis
- los resultados se combinarán con los datos de los puntos de muestreo y se guardarán en la categoría '${samplingPointDataWhispCategoryName}'
- si la categoría '${samplingPointDataWhispCategoryName}' ya existe, su contenido será reemplazado
- el análisis se ejecuta en segundo plano y puede tardar varios minutos, dependiendo del número de puntos de muestreo`,
    },
    templateFor_samplingPointDataImport_csv: 'Plantilla para importación de datos de puntos de muestreo (CSV)',
    templateFor_samplingPointDataImport_xlsx: 'Plantilla para importación de datos de puntos de muestreo (Excel)',
  },
  extraProp: {
    label: 'Propiedad extra',
    label_other: 'Propiedades extra',
    addExtraProp: 'Añadir propiedad extra',
    dataTypes: {
      geometryPoint: 'Punto de geometría',
      number: 'Número',
      text: 'Texto',
    },
    editor: {
      title: 'Editar $t(extraProp.label_other)',
      confirmDelete: '¿Eliminar la propiedad extra "{{name}}"?',
      confirmSave:
        '¿Guardar los cambios en las definiciones de propiedades extra?\n\n**Advertencias**:\n\n{{warnings}}',
      warnings: {
        nameChanged: 'Nombre cambiado de {{nameOld}} a {{nameNew}}',
        dataTypeChanged: 'Tipo de datos cambiado de {{dataTypeOld}} a {{dataTypeNew}}',
      },
    },
    name: 'Nombre de la propiedad {{position}}',
    value: 'Valor',
  },
  record: {
    ancestorNotFound: 'Nodo ancestro no encontrado en el registro',
    keyDuplicate: 'Clave de registro duplicada',
    oneOrMoreInvalidValues: 'Uno o más valores no son válidos',
    uniqueAttributeDuplicate: 'Valor duplicado',
    attribute: {
      customValidation: 'Valor no válido',
      uniqueDuplicate: 'Valor duplicado',
      valueInvalid: 'Valor no válido',
      valueRequired: 'Valor requerido',
    },
    entity: {
      keyDuplicate: 'Clave de entidad duplicada',
    },
    nodes: {
      count: {
        invalid: 'Los nodos {{nodeDefName}} deben ser exactamente {{count}}',
        maxExceeded: 'Los nodos {{nodeDefName}} deben ser menores o iguales a {{maxCount}}',
        minNotReached: 'Los nodos {{nodeDefName}} deben ser mayores o iguales a {{minCount}}',
      },
    },
  },
  expressionEditor: {
    and: 'Y',
    or: 'O',
    group: 'Grupo ()',
    var: 'Variable',
    const: 'Valor constante',
    call: 'Función',
    operator: 'Operador',
    geoCoordinateAtDistanceEditor: {
      coordinateAttributeOrigin: 'Atributo de coordenada de origen',
      distanceAttribute: 'Atributo de distancia',
      bearingAttribute: 'Atributo de rumbo',
    },
    coordinateAttributeWithPosition: 'Atributo de coordenada {{position}}',
    dateTimeDiffEditor: {
      firstDateAttribute: 'Primer atributo de fecha',
      firstTimeAttribute: 'Primer atributo de hora',
      secondDateAttribute: 'Segundo atributo de fecha',
      secondTimeAttribute: 'Segundo atributo de hora',
    },
    error: {
      selectOneVariable: 'Por favor, seleccione una variable',
    },
    header: {
      editingExpressionForNodeDefinition: 'Editando expresión {{qualifier}} para "{{nodeDef}}"',
      editingFunctionForNodeDefinition: 'Editando función "{{functionName}}" para "{{nodeDef}}"',
    },
    qualifier: {
      'default-values': 'valor predeterminado',
      'default-values-apply-if': 'aplicar si el valor predeterminado',
      'editable-if': 'editable si',
      'max-count': 'recuento máximo',
      'min-count': 'recuento mínimo',
      'relevant-if': 'relevante si',
      validations: 'regla de validación',
      'validations-apply-if': 'aplicar si la regla de validación',
      'visible-if': 'visible si',
    },
    selectAFunction: 'Seleccionar una función',
    valueType: {
      constant: 'Constante',
      expression: 'Expresión',
    },
  },
  urls: {
    openforisWebsite: 'https://www.openforis.org',
    openforisArenaWebsite: '$t(urls.openforisWebsite)/arena',
    supportForum: 'https://openforis.support',
  },
  links: {
    openforis: '<a href="$t(urls.openforisWebsite)" target="_blank" rel="noopener noreferrer">$t(common.openForis)</a>',
    openforisArenaWebsite:
      '<a href="$t(urls.openforisArenaWebsite)" target="_blank" rel="noopener noreferrer">$t(urls.openforisArenaWebsite)</a>',
    supportForum: '<a href="$t(urls.supportForum)" target="_blank" rel="noopener noreferrer">$t(urls.supportForum)</a>',
    arenaVideoTutorialsInFaoElearningAcademy:
      '<a href="https://elearning.fao.org/course/view.php?id=1455" target="_blank" rel="noopener noreferrer">FAO elearning Academy</a>',
    arenaVideoTutorialsInYouTube:
      '<a href="https://www.youtube.com/playlist?list=PL0Rrgop7D4QAWSJMtRQojzKuhF4vPS6Rs" target="_blank" rel="noopener noreferrer">YouTube</a>',
    arenaInGitHub:
      '<a href="https://github.com/openforis/arena" target="_blank" rel="noopener noreferrer">https://github.com/openforis/arena</a>',
    arenaRScriptsInGitHub:
      '<a href="https://github.com/openforis/arena-r" target="_blank" rel="noopener noreferrer">https://github.com/openforis/arena-r</a>',
  },
  aiExpression: {
    title: 'Generar expresión a partir de una descripción',
    hint: 'Describa en lenguaje sencillo lo que debe hacer la expresión. La IA la traducirá a la sintaxis de Arena. Presione Ctrl+Enter para generar.',
    placeholder: 'p. ej. la altura del árbol debe ser mayor que 0 y menor que 200',
    generate: 'Generar',
    generating: 'Generando…',
    use: 'Usar esta expresión',
    useAnyway: 'Usar de todos modos',
    tryAgain: 'Probar con otra descripción',
    parseError:
      'La expresión generada no se pudo analizar correctamente: {{message}}. Aun así puede aplicarla y editarla a mano, o intentar reformularla.',
    explain: {
      title: 'Explicar esta expresión',
      thinking: 'Pidiendo a la IA que explique esta expresión…',
      error: 'Error al obtener la explicación: {{message}}',
      timeout: 'La IA tardó demasiado en responder. Inténtelo de nuevo.',
    },
  },
  aiTranslation: {
    translateButton_one: 'Traducir a {{count}} otro idioma',
    translateButton_other: 'Traducir a {{count}} otros idiomas',
    translateButton: 'Traducir a otros idiomas',
    success_one: 'Traducido a {{count}} idioma. Revise y guarde.',
    success_other: 'Traducido a {{count}} idiomas. Revise y guarde.',
    success: 'Traducido. Revise y guarde.',
    failed: 'La traducción falló: {{message}}',
    timeout: 'La solicitud de traducción ha caducado. Inténtelo de nuevo.',
  },
  aiActivityLog: {
    title: 'Resumen del registro de actividad',
    summarizeButton: 'Resumir',
    thinking: 'Agregando eventos y pidiendo a la IA que los resuma…',
    error: 'Error al obtener el resumen: {{message}}',
  },
  aiChatbot: {
    open: 'Ayuda y documentación',
    title: 'Ayuda y documentación',
    empty: 'Pregúnteme lo que quiera sobre Open Foris Arena.',
    placeholder: 'Escriba su pregunta…',
    send: 'Enviar',
    stop: 'Detener',
    clear: 'Borrar',
    showReasoning: 'Mostrar razonamiento',
    error: 'Error del chatbot: {{message}}',
    language: 'Idioma de respuesta',
  },
}
